import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import InputSimulation from '../components/InputSimulation';
import Problem from '../components/Problem';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import CTA from '../components/CTA';
import Footer from '../components/Footer';

const Landing = () => {
  return (
    <div className="Landing">
      <Header />
      <div className="pt-[72px]">
        <Hero />
        <InputSimulation />
        <Problem />
        <HowItWorks />
        <Benefits />
        <CTA />
        <Footer />
      </div>
    </div>
  );
};

export default Landing;